<template>
  <div>
    <van-tabs
      v-if="
        operationId === '637e38de01bd4294b4a488d4124ef2f9' ||
          operationId === 'all'
      "
      v-model="active"
      @change="tabChange"
      :lazy-render="false"
      color="#ff6600"
    >
      <van-tab title="自提点">
        <site-component ref="site"></site-component>
      </van-tab>
      <van-tab
        title="智能柜"
        v-if="operationId === '637e38de01bd4294b4a488d4124ef2f9'"
      >
        <cab-component ref="cab"></cab-component>
      </van-tab>
      <van-tab title="快递柜" v-if="operationId === 'all'">
        <ty-cab-component ref="cab"></ty-cab-component>
      </van-tab>
    </van-tabs>
    <div v-else>
      <site-component ref="site"></site-component>
    </div>
  </div>
</template>
<script>
import siteComponent from './data.vue'
import cabComponent from './data_nanxunCab.vue'
import tyCabComponent from './data_tyCab.vue'
export default {
  data() {
    return {
      active: 0,
      operationId: ''
    }
  },
  components: {
    siteComponent,
    cabComponent,
    tyCabComponent
  },
  created() {
    this.operationId =
      this.$route.query.ope ?? '637e38de01bd4294b4a488d4124ef2f9'
  },
  mounted() {
    this.$refs.site.initChart()
  },
  methods: {
    tabChange(e) {
      if (e) {
        this.$refs.cab.initChart()
      } else {
        this.$refs.site.initChart()
      }
    }
  }
}
</script>
<style lang="scss"></style>
